import { render, staticRenderFns } from "./ApprovalRemarkList.vue?vue&type=template&id=1c57f93c&scoped=true"
import script from "./ApprovalRemarkList.vue?vue&type=script&lang=js"
export * from "./ApprovalRemarkList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRemarkList.vue?vue&type=style&index=0&id=1c57f93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57f93c",
  null
  
)

export default component.exports